import { render, staticRenderFns } from "./AssignedDistributors.vue?vue&type=template&id=2b03ea0a&scoped=true"
import script from "./AssignedDistributors.vue?vue&type=script&lang=js"
export * from "./AssignedDistributors.vue?vue&type=script&lang=js"
import style0 from "./AssignedDistributors.vue?vue&type=style&index=0&id=2b03ea0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03ea0a",
  null
  
)

export default component.exports